import "./upload-file.scss";
import { useEffect, useState } from "react";
import { downLoadFileById, fileUpload } from "../../services/fileServices";
import { toast } from "react-toastify";
import { actualFileType, DEFAULT_FILE_TYPES } from "./uploadFileConsts";
import clsx from "clsx";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import CustomTooltip from "../custom-tooltip";

type IProps = {
  label: string;
  required?: boolean;
  setFieldValue: (data: string) => void;
  fileName: string;
  fileType: string;
  allowFileTypes?: string[];
  errors?: string;
  isReadOnly?: boolean;
};

function FileUpload(props: IProps) {
  const { label, required, setFieldValue, fileName, errors, allowFileTypes = DEFAULT_FILE_TYPES, isReadOnly, fileType } = props;
  const { lang } = useMultiLanguage();
  const [selectedFile, setSelectedFile] = useState<any>({});

  useEffect(() => {
    setSelectedFile({
      name: fileName || ""
    });
  }, [fileName])

  const onChange = async (e: any) => {
    let files = e.target.files[0];
    const isValidMaxSize = files.size > 10048576
    const isValidFileType = actualFileType.find((item) => allowFileTypes.includes(item.id) && item.value === files.type);
    if (!isValidFileType) {
      toast.error(lang("TOAST.ERROR.FORMAT.FILE"));
      return;
    }
    if (isValidMaxSize) {
      toast.error(lang("TOAST.ERROR.LARGE.FILE"))
      return;
    }
    try {
      const data = await fileUpload(files, fileType);
      await setSelectedFile(files);
      await setFieldValue(data?.data?.data?.name);
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    }
  };

  const handleDownLoadFile = async (fileId: string) => {
    try {
      const res = await downLoadFileById(fileId);
      const url = window.URL.createObjectURL(new Blob([res?.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    }
  };

  return (
    <>
      <div className="text-lable-input lable">
        <span>{lang(label)}</span>
        {required && <span style={{ color: "red" }}> *</span>}
      </div>
      <div className={clsx(
        "custom-file-upload gap-2",
        { "form-control is-invalid": errors },
        { "disabled": isReadOnly }
      )}>
        <CustomTooltip
          title={lang("SELECT.FILE")}
          placement="auto"
          className={clsx(
            { "hidden": isReadOnly }
          )}
        >
          <label className={`flex flex-middle flex-shrink-1 flex-grow-0 overflow-hidden ${!isReadOnly && "cursor-pointer"}`}>
            <input type="file" onChange={onChange} accept={allowFileTypes.join(',')} readOnly={isReadOnly} disabled={isReadOnly} />
            <span className="icon-upload-file">
              <i className="bi bi-cloud-arrow-up-fill text-primary me-1 fs-4" />
            </span>
            <span className="file-preview">{selectedFile?.name || ""}</span>
          </label>
        </CustomTooltip>
        <CustomTooltip
          title={lang("DOWNLOAD.FILE")}
          placement="right"
          className={clsx(
            { "hidden": isReadOnly || !selectedFile.name }
          )}
        >
          <div
            className={clsx(
              "bi bi-download",
              { "cursor-pointer": !isReadOnly && selectedFile.name}
            )}
            onClick={() => !isReadOnly && selectedFile?.name && handleDownLoadFile(selectedFile?.id)}
          ></div>
        </CustomTooltip>
      </div >
      {errors && <div className='invalid-feedback'>{errors}</div>
      }
    </>
  );
}

export default FileUpload;
